module.exports = __webpack_public_path__ + "static/img/tunnel page top img_mobile.987c2148.jpg";